module.exports = __webpack_public_path__ + "videos/3d-model_jp.a18d77a.mp4";